export default __webpack_public_path__ + "static/media/press.2287dbe4.jpg";